import { useEffect, useState } from 'react';

type HeaderChange = {
  backButtonLink?: string;
  currentStep?: number;
  totalSteps?: number;
};

interface Props {
  onHeaderChange?: (headerChange: HeaderChange) => void;
}

const EVENT_NAME = 'tikkie-claim-header-change';

export function useClaimNavigationHeader(props?: Props) {
  const [backButtonLink, setBackButtonLink] = useState<string>();
  const [currentStep, setCurrentStep] = useState<number>();
  const [totalSteps, setTotalSteps] = useState<number>();

  const updateHeader = (infos: HeaderChange) => {
    dispatchEvent(new CustomEvent(EVENT_NAME, { detail: infos }));
  };

  const handleHeaderChange = (event: Event) => {
    const { detail } = event as CustomEvent<HeaderChange>;

    if (!detail) {
      return;
    }

    setBackButtonLink(detail.backButtonLink);
    setCurrentStep(detail.currentStep);
    setTotalSteps(detail.totalSteps);

    props?.onHeaderChange?.(detail);
  };

  useEffect(() => {
    window.addEventListener(EVENT_NAME, handleHeaderChange);

    return () => {
      window.removeEventListener(EVENT_NAME, handleHeaderChange);
    };
  });

  return {
    updateHeader,
    backButtonLink,
    currentStep,
    totalSteps,
  };
}
